import React, { Component } from 'react';
import Config from './Config';
import List from './List';
import { Scrollbars } from 'react-custom-scrollbars';
import './css/StockTake.css';
import FX from './functions/functions';
import Modal from './Modal';

class StockTake extends Component {
  constructor(props) {
    super(props)
    this.state = {activeCustomer: null, options:{}, checked:[], updated:[], showStock:false};
    FX.urlRetrieve.bind(this)(this.props.root.state);
  }
  componentDidMount(){
    console.log('oooo');
    this.retrieveData(30);
  }
  componentWillMount(){
     //FX.urlRetrieve.bind(this)(this.props.root.state);
  }
  retrieveData = (limit) => {
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {sort: sort_str, limit: 'all'};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'customer' + qs , (res, i) => {
      var state = this.props.root.state;
      this.props.root.setState({customers: res.customers});
      console.log(res);
      console.log(state);
    });
  }
  commitStockTake = (complete) => {
    if(!complete){
      this.setState({committing: true});
    }
    else {
      var reason = '';
      if(this.state.reason){
        reason = this.state.reason;
      }
      FX.load(this.props.root,'stockTake/commit' , (res, i) => {
            console.log(res);
            console.log(res.success);
            if(res.success){
               this.selectCustomer(undefined);
               console.log(res);
            }
            this.props.root.changed = false;
      }, {method:'POST',data:{ checked : this.state.checked,customer_id: this.state.activeCustomer, reason: reason, user: this.props.root.state.user}});
      this.setState({committing: undefined});
    }
  }
  showProduct = () => {
    this.setState({showProduct: !this.state.showProduct})
  }
  upImg = (e) => {
    
     console.log(e);
     console.log(e.nativeEvent);
     console.log(e.target);
     if(!e.target.files.length){
       return false;
     }
     var reader = new FileReader();
     
     reader.onload = (event) => {
       
         var pro;
         
         console.log(e);
         var prods = this.state.products;
         prods.some((prod) =>{
            if(prod.id == this.state.activeProduct.id){
              pro = prod;
              return true;
            }
         });
       
         console.log( this.state.productModal);
         console.log(pro);
       
       
          console.log(event);
          var dataUri = event.target.result,
          img = document.createElement("img");
          img.src = dataUri;
          img.className = 'img_new';
          var width = img.width;
          var height = img.height;
          var fileSize = img.size;
          //alert(width);
          //alert(height);
          //alert(fileSize);
          document.getElementById('nu_img').appendChild(img);
          
          
        //var img = document.querySelector('.img_new');
        var inu = FX.getBase64Image(img);
          
          pro.image.push({id: -1, add:true, img : event.target.result });
          console.log(img);
     };
     reader.onerror = function(event) {
         console.error("File could not be read! Code " + event.target.error.code);
     };
     reader.readAsDataURL(e.target.files[0]);
     
     console.log(e.target.files);
     console.log(e.target.value = '');
     
  }
  toggleStock = () => {
    this.setState({showStock:!this.state.showStock})
  }
  addLocation = (pro, e) => {
      console.log(e);
      console.log(pro);
      var prods = this.state.products;
      var newLoc;
      if(document.getElementById("addLocation") && (newLoc = document.getElementById("addLocation").value)){
          prods.some((prod,i) =>{
            if(prod.id == this.state.activeProduct.id){
              prod.locations.push({id: -1, warehouse_id: 1, reference: newLoc, product_id: pro.id});
              prods[i] = prod;
              return true;
            }
          });
          this.setState({products: prods});
      }
      document.getElementById("addLocation").value = '';
  }
  removeLocation = (index, e) => {
      console.log(e);
      var prods = this.state.products;
      
      prods.some((prod,i) =>{
        if(prod.id == this.state.activeProduct.id){
          prod.locations.splice(index, 1);
          prods[i] = prod;
          return true;
        }
      });
      this.setState({products: prods});
      
      document.getElementById("addLocation").value = '';
  }
  productHandler = (target, e) => {
      var prods = this.state.products;
      prods.some((prod, i) =>{
          console.log(this.state.activeProduct);
          console.log(prod.id);
        if(prod.id == this.state.activeProduct.id){
          console.log(prod);
          prod[target] = e.target.value;
          prods[i] = prod;
          console.log(prod);
          return true;
        }
        return false;
      });
      this.setState({products: prods});
  }
  saveProduct = (e) => {
      console.log(e);
      var pro;
      var prods = this.state.products;
      var detail = this.props.root.state.detail;
      prods.some((prod , i) =>{
        if(prod.id == this.state.activeProduct.id){
          pro = prod;
          return true;
        }
      });
      FX.load(this.props.root,'product' , (res, i) => {
          console.log("Product Saved");
          console.log(res);
          console.log(res.success);
          if(res.product){
              prods.some((prod, k) =>{
                if(prod.id == res.product.id){
                  //prod = res.product;
                  prods[k] = res.product;
                  prod.updated1 = '010';
                  console.log('___________');
                  return true;
                }
                return false;
              });
              this.setState({products: prods, activeProduct: undefined, showProduct: undefined});
            
          }
          if(res.success){
             this.closeModal();
          }
    }, {method:'PUT',data:{ product : {id : pro.id,locations: pro.locations, barcode : pro.barcode, image : pro.image} }}, document.querySelectorAll('.img_new').length > 0);
    console.log(pro);
  }
  retrieveDetail = (id) => {
    console.log('pop');
    if(id == null || id == undefined || !id){
        console.log('pip');
        this.props.root.setState({ detail : null  });
    }
    else {
        var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
        FX.load(this.props.root,'order/' + id , (res, i) => {
          console.log(res.order);
          if(res.order && res.order.id){
            this.props.root.setState({ detail : res.order  });
          }
          else {
            FX.navigate.bind(this.props.root, this.props.root.state.panel, undefined ,'/orders')();
          }
        });
    }
  }
  showList = () => {
    FX.navigate.bind(this.props.root, this.props.root.state.panel, undefined ,'/orders')();
  }
  selectCustomer = (customer_id) => {
    this.props.root.changed = {message:'This Stock Take has not been completed. Are you sure you wish to leave?'};
    console.log(customer_id);
    this.props.root.setState({ detail : null  });
    if(customer_id == null || customer_id == undefined || !customer_id){
        console.log('pip');
        this.setState({activeCustomer : null, products : undefined});
    }
    else{
        this.setState({activeCustomer : customer_id, products : undefined});
        var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
        var data = {customer_id: customer_id, sort: sort_str, limit: 'all'};
        var qs = FX.encodeQueryData(data, true);
        FX.load(this.props.root,'product' + qs , (res, i) => {
          var state = this.props.root.state;
          this.setState({products: res.products});
          console.log(res);
          console.log(state);
        });
    }
  }
  checkProduct = (product) => {
    console.log(product);
    this.setState({activeProduct : product});
  }
  checkProductCount = () =>{
    var checked = this.state.checked;
    
    var found = false;
    checked.some((check, i) => {
       if(check.product.id == this.state.activeProduct.id){
         checked[i].count = parseInt(document.getElementById('item_count').value,10)
         return found = true;
       }
       return false;
    });
    
    if(!found){
      checked.push({product: this.state.activeProduct, count: FX.numberFix(document.getElementById('item_count').value)});
    }
    
    
    console.log(checked);
    console.log(this.state.activeProduct.stock);
    console.log(this.state.activeProduct.stock_alloc);
    console.log(this.state.activeProduct.stock_exp);
    console.log(this.state.activeProduct.stock_pre_order);
    
    console.log(this.state.activeProduct.stock);
    console.log(document.getElementById('item_count').value);
    
    this.setState({checked:checked});
  }
  retrieveProducts = (customer_id) => {
    console.log(customer_id);
    this.setState({activeCustomer : customer_id, products : undefined,activeProduct : undefined})
  }
  closeModal = (prod_id) => {
    this.setState({activeProduct:undefined, committing: false, showProduct: false});
  }
  render() {
    console.log(this.props.root.state);
    if(this.state.activeCustomer && this.state.activeCustomer){
      var customers = this.props.root.state.customers;
      var product_list;
      if(this.state.products){
        var prods = [];
        this.state.products.forEach((prod) => {
          if(!prod.composite && prod.status == 1){
            prods.push(prod);
          }
        })
        
        
        
        product_list = prods.map((prod) => {
          if(!prod.composite){
              var locate = '';
              var className = "prod_line";
              var stock;
              var update;
              this.state.checked.some((check) => {
                 if(check.product == prod.id){
                   className += " checked";
                   return true;
                 }
                 return false;
              });
              this.state.checked.some((check) => {
                 if(check.product.id == prod.id){
                   className += " checked";
                   update = check;
                   return true;
                 }
                 return false;
              });
              if(this.state.updated && this.state.updated.indexOf(prod.id) !== -1){
                className += " updated";
              }
              if(prod.locations){
                  prod.locations.forEach((loc) => {
                      if (locate) locate += ', ';
                      locate += loc.reference;
                  });
              }
              if(this.state.showStock){
                if(update && parseInt(update.count,10) !== parseInt(prod.stock,10)){
                    stock = <div><span className="strike">{prod.stock}</span>{update.count}</div> ;
                }
                else if(update && parseInt(update.count,10) === parseInt(prod.stock,10)){
                    stock = <div><span className="match">{prod.stock}</span></div> ;
                }
                else {
                    stock = <div>{prod.stock}</div> ;
                }
              }
              var name= prod.name ? prod.name : (<span className="noName">[No Name]</span>);
              return ( <span onClick={this.checkProduct.bind(this, prod)} className={className}>
                        <span className="name">{name}</span>
                        <span className="sku">{prod.sku}</span>
                        <span className="stock">{stock}</span>
                        <span className="locations">{locate}</span>
                      </span>
                     )
          }
        });
        
        
        
      }
      var customer = {name: ''};
      if(customers){
        customers.some((cust) => {
          if(cust.id == this.state.activeCustomer)
            return (customer = cust);
         
          return false;
        });
      }
      console.log(customer);
      var modal;
      var pro = this.state.activeProduct;
      
      
      if(pro){
        
        var locations = pro.locations.map( (loc, i) => {
         return (
            <div className="location">
              {loc.reference}
              <i style={{float: 'right'}} onClick={this.removeLocation.bind(this,i)} className="material-icons">close</i>
            </div>
          );
        });
        
        
            locations = (
                <div className="locations">
                    <h4>Locations</h4>
                    <Scrollbars style={{ width: 250 }}>
                        {locations}
                        <div className="add_location"><i className="material-icons">add_circle_outline</i><input id="addLocation"/><button onClick={this.addLocation.bind(this,pro)}><i className="material-icons">add</i></button></div>
                    </Scrollbars>
                </div>
            );
        
        
        var images = pro.image.map( img => {
         return (
            <div className="image">
              <img src={this.props.root.paths.imgHost + img.path} />
              <i style={{float: 'right'}} className="material-icons">close</i>
            </div>
          );
        });
        
        var confirmCount;
          if(this.state.checked && this.state.checked.indexOf(pro.id) !== -1){
             confirmCount = <div><div>{pro.stock}</div></div>
          }
        
        
        /*
       modal = (<Modal close={this.closeModal} title="Product" >
                            <div>{pro.sku} - {pro.name}</div>
                            <div><input value={pro.barcode} /><button>Update</button></div>
                            
                            <div className="images">
                            <h4>Images</h4>
                                {images}
                                <div id="nu_img"></div>
                                <div className="add_image"><i className="material-icons">add_circle_outline</i><input id="newImg" type="file" onChange={this.upImg} /></div>
                            </div>
                            
                            <div>
                            <input id="item_count"/>
                            <button onClick={this.checkProductCount}>Check</button>
                            </div>
                            {confirmCount}
                            <div className="locations">
                            <h4>Locations</h4>
                            
                            <Scrollbars style={{ width: 200 }}>
                                {locations}
                                <div className="add_location"><i className="material-icons">add_circle_outline</i><input value=""/></div>
                            </Scrollbars>
                            </div>
                        </Modal>);
                        */
                        
                        
                        
                        
                        if(this.state.showProduct){
                        
                        modal = (<Modal buttons={[{text:'Back', left:true ,action:this.showProduct},{text:'Cancel',action:this.closeModal},{text:'Save',action:this.saveProduct}]} close={this.closeModal} title="Product" >
                            
                            <div className="info">
                                <div className="title" >
                                  <div>{pro.sku}</div>
                                  <div>{pro.name}</div>
                                </div>
                                <div><label>Barcode:</label><input value={pro.barcode} onChange={this.productHandler.bind(this,'barcode')} /></div>
                                
                                
                                <div className="images">
                                <h4>Images</h4>
                                    {images}
                                    <div id="nu_img"></div>
                                    <div className="add_image">&nbsp;<i className="material-icons">add_circle_outline</i><input id="newImg" type="file" onChange={this.upImg} /></div>
                                </div>
                                {locations}
                            </div>
                            
                            
                        </Modal>);
                        
                       }
                       else {
                        
                        
                        modal = (<Modal buttons={[{text:'Show Product', left:true ,action:this.showProduct},{text:'Cancel',action:this.closeModal},{text:'Check',action:() => {this.checkProductCount(); this.closeModal();} }]} close={this.closeModal} title="Product" >
                            
                            <div className="info">
                              <div className="title" >
                                <div>{pro.sku}</div>
                                <div>{pro.name}</div>
                              </div>
                                
                                <input id="item_count"/>
                            </div>
                            
                            
                        </Modal>);
                        
                       }
                        
                        
                        
                        
                        
                        
                        
                        
                        
      
     }
      if(this.state.committing){
        var take = this.state.checked.map(check =>{
          return (<tr className="check_line">
                    <td><div className="name">{check.product.name}</div>
                    <div className="sku">{check.product.sku}</div></td>
                    <td className="expected">{check.product.stock}</td>
                    <td className="count">{check.count}</td>
                    <td className="difference">{((check.count - check.product.stock) > 0 ? '+' : '') + (check.count - check.product.stock)}</td>
                  </tr>)
        })
        modal = (<Modal buttons={[{text:'Cancel',action:this.closeModal},{text:'Complete',action:this.commitStockTake.bind(this,true)}]} close={this.closeModal} title="Commit Stock Take" >
                    <div className="info">
                        <Scrollbars className="checkedList">
                          <div>
                            <h3>Checked Items</h3>
                            <table>
                            <tr className="check_line">
                              <th>Product</th>
                              <th className="expected">Expected Count</th>
                              <th className="count">Actual</th>
                              <th className="difference">Difference (+/-)</th>
                            </tr>
                            {take}
                            </table>
                          </div>
                        </Scrollbars>
                        <h5>Reason for Stock Take</h5>
                        <textarea className="reason" value={this.state.reason} onChange={FX.handle.bind(this,this,'reason')}/>
                    </div>
                </Modal>);
      }
      
      return (
        <div className="StockTake">
          <div className="subTopBar">
            <div className="back_btn" onClick={this.selectCustomer.bind(this, undefined)} ><i className="fa fa-angle-left" /> Back</div>
            <div className="commit" onClick={this.commitStockTake.bind(this,false)} >Commit</div>
            <div className="show_count" onClick={this.toggleStock.bind(this,false)} >Show Stock</div>
            <div className="cust_name">{customer.name}</div>
          </div>
          <div>
            <div>
              {product_list}
            </div>
          </div>
          {modal}
        </div>
      );
    }
    else {
      var customers = this.props.root.state.customers;
      var cust_list;
      if(customers){
        cust_list = customers.map((cust) => {
          if(cust.status == 1){
              return <span onClick={this.selectCustomer.bind(this, cust.id)} className="customerCard"><img/><span>{cust.name}</span></span>
          }
        })
      }
      return (
        <div className="StockTakes">
          {cust_list}
        </div>
      );
    }
  }
}

export default StockTake;



// WEBPACK FOOTER //
// ./src/StockTake.js